import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_d9209dff91c5011c0bcd8827e759d9b0",
  "use": "add_d9209dff91c5011c0bcd8827e759d9b0-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"add_d9209dff91c5011c0bcd8827e759d9b0\">\n    <path fill-rule=\"evenodd\" d=\"M14.3 8A6.3 6.3 0 1 1 1.7 8a6.3 6.3 0 0 1 12.6 0zm-1.35 0a4.95 4.95 0 1 0-9.9 0 4.95 4.95 0 0 0 9.9 0zm-2.505-.666a.666.666 0 1 1 0 1.332H8.667v1.779a.667.667 0 0 1-1.334 0V8.666H5.555a.666.666 0 0 1 0-1.332h1.778V5.555a.666.666 0 0 1 1.334 0v1.779h1.778z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol